import { render, staticRenderFns } from "./TerritorioParaguai.vue?vue&type=template&id=2ac34e54&lang=pug"
import script from "./TerritorioParaguai.vue?vue&type=script&lang=js"
export * from "./TerritorioParaguai.vue?vue&type=script&lang=js"
import style0 from "./TerritorioParaguai.vue?vue&type=style&index=0&id=2ac34e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports